module.exports = __webpack_public_path__ + "static/img/263_TO8_2345.e0d743d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/263_TO8_2345.jpg
// module id = uQ58
// module chunks = 0